import landing from './view.landing';
import notFound from './view.404';
import signIn from './view.signIn';
import signUp from './view.signUp';

const view = {
  landing,
  notFound,
  signIn,
  signUp,
};

export default view;
